import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
    Box,
    Card,
    CardContent,
    Typography,
    CircularProgress,
    IconButton
} from '@material-ui/core';
import { getUserCount } from '../UserManagement/actions';
import { useDispatch } from 'react-redux';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, BarChart, Bar, ComposedChart
} from 'recharts';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ZoomInIcon from '@material-ui/icons/ZoomIn';
import ZoomOutIcon from '@material-ui/icons/ZoomOut';
import { Col, Row } from 'react-bootstrap';

const useStyles = makeStyles((theme) => ({
    card: {
        maxWidth: "100%",
        margin: 'auto',
        marginTop: theme.spacing(5),
        borderRadius: theme.spacing(2),
        overflow: 'hidden',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
    },
    cardContent: {
        padding: theme.spacing(2),
    },
    button: {
        marginBottom: theme.spacing(2),
    },
    chartTitle: {
        marginBottom: theme.spacing(2),
    },
    loader: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '300px',
    },
    backButton: {
        marginRight: theme.spacing(2),
    },
}));

const UserDashboard = (props) => {
    const classes = useStyles();
    const [data, setData] = useState([]);
    const [selectedYear, setSelectedYear] = useState(null);
    const [loading, setLoading] = useState(true);
    const [zoomIn, setZoomIn] = useState(true); // Initially zoom in
    const dispatch = useDispatch();

    useEffect(() => {
        fetchData("year");
    }, []);

    const fetchData = async (mode, year = null) => {
        setLoading(true);
        const result = await dispatch(getUserCount(mode, year));
        setData(result);
        setLoading(false);
    };

    const handleYearClick = (data, index) => {
        // console.log("debugg :: ", data);
        if(data){
            setSelectedYear(data.activeLabel);
            fetchData("month", data.activeLabel);
        }
    };

    const handleBackToYearData = () => {
        fetchData("year");
        setSelectedYear(null);
    };

    const handleBarClick = (barData, index) => {
        console.log("Bar clicked:", barData);
        // Add your logic for handling bar click here
    };

    const handleZoomClick = () => {
        if (props.onZoomClick) {
            if (zoomIn) {
                props.onZoomClick("UserDashboard")
            }
            else {
                props.onZoomClick("zoom")

            }
        }

        setZoomIn(!zoomIn); // Toggle between zoom in and zoom out
    };

    return (
        <Card className={classes.card}>
            <CardContent className={classes.cardContent}>
                {loading ? (
                    <Box className={classes.loader}>
                        <CircularProgress />
                    </Box>
                ) : (
                    <>
                        {!selectedYear ? (
                            <>
                                <Row>
                                    <Col>
                                        <Typography variant="h5" component="div" className={classes.chartTitle}>
                                            Acquired users
                                        </Typography>
                                    </Col>
                                    <Col style={{ display: "flex", justifyContent: "end" }}>
                                        <IconButton
                                            color="primary"
                                            className={classes.button}
                                            onClick={handleZoomClick}
                                        >
                                            {zoomIn ? <ZoomInIcon /> : <ZoomOutIcon />}
                                        </IconButton>
                                    </Col>
                                </Row>


                            </>
                        ) : (
                            <>
                                <Box display="flex" alignItems="center" marginBottom={2}>
                                    <IconButton
                                        edge="start"
                                        color="inherit"
                                        onClick={handleBackToYearData}
                                        className={classes.backButton}
                                    >
                                        <ArrowBackIosIcon />
                                    </IconButton>
                                    <Typography variant="h4" component="div" className={classes.chartTitle}>
                                        Monthly Data for {selectedYear}
                                    </Typography>
                                </Box>
                            </>
                        )}

                        <ResponsiveContainer width="100%" height={300}>
                            <ComposedChart data={data} onClick={handleYearClick}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey={selectedYear ? "month" : "year"} />
                                <YAxis yAxisId="left" />
                                <YAxis yAxisId="right" orientation="right" />
                                <Tooltip />
                                <Legend />
                                <Bar
                                    dataKey="user_count"
                                    yAxisId="left"
                                    fill="#8884d8"
                                    barSize={15}
                                    radius={[10, 10, 0, 0]}
                                    name="User Count"
                                    onClick={handleBarClick}
                                />
                                <Line
                                    yAxisId="right"
                                    type="monotone"
                                    dataKey="growth_rate"
                                    stroke="#ff7300"
                                    name="Growth Rate"
                                />
                            </ComposedChart>
                        </ResponsiveContainer>
                    </>
                )}
            </CardContent>
        </Card>
    );
};

export default UserDashboard;
